module.exports = __webpack_public_path__ + "images/category_lp/brand/assessment_achievements/5_cc387a9dbc461c87ff08a208e1e8bfb9.jpg";